<template>
  <div style="padding-top: 16px" id="page-container">
    <!-- <page-header :title="title" :container-class="containerClass" /> -->

    <div class="page-section jobs_container">
      <div :class="containerClass">
        <div class="d-flex flex-column flex-sm-row align-items-sm-center mb-24pt" style="white-space: nowrap">
          <h2 class="mb-0">
            Discussion Board

            <i
              class="material-icons icon-16pt clickable-item"
              v-b-popover.hover.top="`Manage and participate in discussions.`"
              >info</i
            >
          </h2>

          <div class="w-auto ml-sm-auto mb-sm-0">
            <div class="d-flex flex-wrap align-items-center justify-content-end" style="gap: 8px;">
              <form
                class="search-form search-form--light"
                style="min-width: 220px;"
                @submit.prevent=""
              >
                <b-form-input
                  class="w-100"
                  v-model="searchTerm"
                  @input="onSearch"
                  placeholder="Search by title or student name"
                />
                <b-btn variant="flush" type="submit">
                  <md-icon>search</md-icon>
                </b-btn>
              </form>
              <div v-if="!isSchoolUser" class="custom-select-icon" style="min-width: 185px;">
                <b-form-select
                  class="custom-select-icon__select"
                  v-model="filters.topic"
                  :options="quesOptions"
                  @change="onFilterApplied"
                ></b-form-select>
                <span class="material-icons custom-select-icon__icon">sort</span>
              </div>
              <b-btn v-if="isSchoolUser" @click.prevent="areFiltersOpen = !areFiltersOpen" variant="primary">
                {{ areFiltersOpen ? 'Hide Filters' : 'Filters' }}
              </b-btn>
              <b-btn @click.prevent="goToMyQuestions()" variant="outline-primary">Discussions</b-btn>
              <b-btn @click.prevent="addQues()" variant="primary">Start Discussion</b-btn>
            </div>
          </div>
        </div>

        <div
          v-if="areFiltersOpen && isSchoolUser"
          class="d-flex flex-wrap justify-content-end mb-24pt"
          style="gap: 8px;"
        >
          <div
            v-if="[USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN].includes(get(getLoggedInUser, 'role'))"
            style="min-width: 200px;"
          >
            <v-select
              id="program"
              class="form-control v-select-custom"
              label="title"
              v-model="filters.program"
              :reduce="pg => pg.id"
              placeholder="All Programs"
              :options="allPrograms"
              :loading="areProgramsLoading"
              @input="onProgramChange"
              :clearable="true"
            >
            </v-select>
          </div>
          <div
            v-if="[USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN].includes(get(getLoggedInUser, 'role'))"
            style="min-width: 200px;"
          >
            <v-select
              id="tag"
              class="form-control v-select-custom"
              label="title"
              v-model="filters.tag"
              :reduce="tg => tg.id"
              placeholder="All Tags"
              :options="allTags"
              :loading="areTagsLoading"
              @input="onFilterApplied"
              :disabled="!filters.program"
              :clearable="true"
            >
            </v-select>
          </div>
          <div class="custom-select-icon" style="min-width: 185px;">
            <b-form-select
              class="custom-select-icon__select"
              v-model="filters.topic"
              :options="quesOptions"
              @change="onFilterApplied"
            ></b-form-select>
            <span class="material-icons custom-select-icon__icon">sort</span>
          </div>
        </div>

        <page-separator
          :title="
            !isLoading
              ? `showing ${totalQuestions ? `${pageFromCount}-${pageToCount}` : 0} of ${totalQuestions} Questions`
              : ''
          "
        />

        <div class="d-flex justify-content-center" v-if="!totalQuestions && !isLoading">
          <div class="card card-block card-stretch card-height col-md-12">
            <div class="card-body text-center">
              <i class="fas fa-exclamation-circle fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />
              <h4>No Discussions Found</h4>

              <p class="text-muted">
                Couldn't find any open discussions from the community right now. Feel free to start discussions and get
                help from the students and instructors of your school.
              </p>

              <!-- <a href="#" @click.prevent="" class="btn btn-primary mt-2"> Sample Button </a> -->
            </div>
          </div>
        </div>

        <b-skeleton-wrapper :loading="isLoading" v-else>
          <template #loading>
            <div class="row card-group-row mb-lg-12pt home-card">
              <div class="col-sm-12 card-group-row__col" v-for="item in [1, 2]" :key="item">
                <div class="card overlay--show card-lg overlay--primary-dodger-blue card-group-row__card">
                  <div class="card-header d-flex align-items-center">
                    <a href="#" @click.prevent class="card-title flex"> <b-skeleton width="100%"></b-skeleton></a>
                  </div>
                  <div class="card-body d-flex flex-column">
                    <div class="d-flex align-items-center">
                      <div class="flex">
                        <div class="mb-16pt" :class="{ 'd-flex align-items-center': !isMobSmallScreen }">
                          <div class="mr-12pt" :class="{ 'd-flex justify-content-center mb-3': isMobSmallScreen }">
                            <a
                              href="#"
                              @click.prevent
                              class="avatar avatar-xl overlay js-overlay overlay--primary rounded-circle p-relative o-hidden mb-16pt align-self-center"
                              style="border: 1px solid #dfe2e6"
                            >
                              <b-skeleton-img class="avatar-img" width="160" height="100%"></b-skeleton-img>
                            </a>
                          </div>
                          <div class="flex">
                            <div class="mb-0" style="text-transform: none">
                              <b-skeleton width="100%"></b-skeleton>
                              <b-skeleton width="55%"></b-skeleton>
                              <b-skeleton width="70%"></b-skeleton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="row card-group-row mb-lg-12pt home-card">
            <div class="col-sm-12 card-group-row__col" v-for="ques in questions" :key="ques.id">
              <div class="card overlay--show card-lg overlay--primary-dodger-blue card-group-row__card">
                <div class="card-header d-flex align-items-center">
                  <router-link
                    :to="{
                      name:
                        get(getLoggedInUser, 'role_type') === USER_ROLE_TYPES.ORGANIZATION
                          ? 'org-discussion-details'
                          : 'student-question-details',
                      params: { id: ques.id },
                    }"
                    class="card-title flex mr-12pt"
                    >{{ ques.title }}</router-link
                  >
                </div>

                <router-link
                  :to="{
                    name:
                      get(getLoggedInUser, 'role_type') === USER_ROLE_TYPES.ORGANIZATION
                        ? 'org-discussion-details'
                        : 'student-question-details',
                    params: { id: ques.id },
                  }"
                  class="text-black"
                >
                  <div class="card-body d-flex flex-column">
                    <div class="d-flex align-items-center">
                      <div class="flex">
                        <div class="mb-16pt" :class="{ 'd-flex align-items-center': !isMobSmallScreen }">
                          <div class="mr-12pt" :class="{ 'd-flex justify-content-center mb-3': isMobSmallScreen }">
                            <user-avatar
                              slot="aside"
                              :user="get(ques, 'questioner')"
                              circle="lg"
                              size="5rem"
                              :file-url="get(ques, 'questioner.avatar_url')"
                              variant="dark"
                            >
                            </user-avatar>
                          </div>

                          <div class="flex">
                            <div class="mb-0" style="text-transform: none">
                              <!-- for ques description -->

                              <div>
                                <b
                                  >{{ get(ques, 'questioner.first_name') }} {{ get(ques, 'questioner.last_name') }}
                                  {{
                                    get(ques, 'questioner.title')
                                      ? ques.questioner.title === USER_TITLES.OTHER
                                        ? `(${get(ques, 'questioner.other_title', 'Other')})`
                                        : `(${userTitleOptions[get(ques, 'questioner.title', 'other')].text})`
                                      : ''
                                  }}</b
                                >
                              </div>
                              <div class="mb-2 d-flex justify-content-between flex-wrap">
                                <span class="text-muted">{{ formatDateTime(get(ques, 'updated_at')) }}</span>

                                <div class="badge badge-dark" style="text-transform: none">
                                  {{ $t(`audienceTypes.${ques.audience}`) }}
                                </div>
                              </div>

                              <div class="ques-description-preview" v-safe-html="renderDescription(get(ques, 'description'))"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- for topics -->
                    <div class="card-button">
                      <ul>
                        <li>
                          <a href="#" @click.prevent
                            ><span class="icon-16pt text-100">#</span>{{ $t(`topics.${get(ques, 'topic')}`) }}</a
                          >
                        </li>
                        <li
                          v-if="
                            [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN].includes(get(getLoggedInUser, 'role')) &&
                              get(ques, 'program.title')
                          "
                        >
                          <a href="#" @click.prevent
                            ><span class="material-icons icon-16pt text-100">school</span
                            >{{ get(ques, 'program.title') }}</a
                          >
                        </li>
                        <li
                          v-if="
                            [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN].includes(get(getLoggedInUser, 'role')) &&
                              get(ques, 'tag.title')
                          "
                        >
                          <a href="#" @click.prevent
                            ><span class="material-icons icon-16pt text-100">label</span>{{ get(ques, 'tag.title') }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>

        <pagination
          v-if="totalQuestions > questions.length"
          v-model="currentPage"
          :total-rows="totalQuestions"
          :per-page="perPage"
          @change="onPageChange"
          aria-controls="jobs-table"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import PageHeader from '@/components/Ui/PageHeader.vue';
import { debounce, get, keyBy, trim, truncate } from 'lodash';

import Page from '@/components/Page.vue';
import Pagination from '../../../components/Ui/Pagination.vue';
import UserAvatar from '@/components/User/UserAvatar.vue';
import { mapActions, mapGetters } from 'vuex';

import DefaultAvatar from '@/assets/images/logos/logo_icon.png';
import {
  USER_ROLES,
  USER_TITLES,
  USER_TITLE_OPTIONS,
  DASHBOARD_TYPES,
  USER_ROLE_TYPES,
} from '../../../common/constants';
import { formatDateTime } from '../../../common/utils';
import PageSeparator from '@/components/Ui/PageSeparator.vue';

export default {
  components: { Pagination, UserAvatar, PageSeparator },
  extends: Page,

  data() {
    return {
      DefaultAvatar,
      USER_TITLES,
      USER_ROLE_TYPES,
      title: 'Discussion Board',
      isLoading: true,
      areFiltersOpen: false,
      perPage: 14,
      currentPage: 1,
      totalQuestions: 0,
      questions: [],
      quesOptions: [
        { value: null, text: 'All Questions' },
        { value: 'jobs_options', text: 'Jobs/Options' },
        { value: 'exam_testing', text: 'Exam/Testing' },
        { value: 'skills', text: 'Skills' },
        { value: 'class', text: 'Class' },
        { value: 'equipment', text: 'Equipment' },
        { value: 'general', text: 'General' },
        { value: 'miscellaneous', text: 'Miscellaneous' },
      ],
      pageFromCount: 0,
      pageToCount: 0,
      searchTerm: '',
      filters: {
        topic: null,
        program: null,
        tag: null,
      },
      allPrograms: [],
      allTags: [],
      areProgramsLoading: false,
      areTagsLoading: false,
      windowWidth: window.innerWidth,
      firstLoad: true,
      USER_ROLES,
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser', 'getLoggedInUserDashboard']),

    isSchoolUser() {
      return [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN].includes(get(this.getLoggedInUser, 'role'));
    },

    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Discussion Board', active: true },
      ];
    },

    isMobSmallScreen() {
      return this.windowWidth <= 420;
    },
    isMobileScreen() {
      return this.windowWidth <= 720;
    },

    userTitleOptions() {
      return keyBy(USER_TITLE_OPTIONS, 'value');
    },
  },

  methods: {
    ...mapActions('questions', ['getAllQuestions']),
    ...mapActions('program', ['getSclPrograms']),
    ...mapActions('attendance', ['getTags']),
    get,
    trim,
    truncate,
    formatDateTime,
    renderDescription(description) {
      const content = description || '';
      // TinyMCE content is HTML; render as-is. Legacy plain text: convert newlines to <br>.
      const hasHtml = /<\/?[a-z][\s\S]*>/i.test(content);
      return hasHtml ? content : content.replace(/(?:\r\n|\r|\n)/g, '<br>');
    },
    addQues() {
      this.$router.push({
        name: this.getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION ? 'org-add-discussion' : 'add-ques',
      });
    },
    goToMyQuestions() {
      this.$router.push({
        name: this.getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION ? 'org-my-discussions' : 'my-questions',
      });
    },
    async fetchPrograms() {
      this.areProgramsLoading = true;
      try {
        const res = await this.getSclPrograms();
        this.allPrograms = res.data;
      } catch (e) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.areProgramsLoading = false;
    },
    async fetchTagsForFilter() {
      if (!this.filters.program) {
        this.allTags = [];
        this.filters.tag = null;
        return;
      }
      this.areTagsLoading = true;
      try {
        const res = await this.getTags({ program__id: this.filters.program });
        this.allTags = res.data.data;
      } catch (e) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.areTagsLoading = false;
    },
    async onProgramChange() {
      await this.fetchTagsForFilter();
      this.fetchQuestions();
    },
    onFilterApplied() {
      this.fetchQuestions();
    },
    async fetchQuestions(pageNum = 1, params = {}) {
      this.isLoading = true;
      if (document.getElementById('page-container')) {
        document.getElementById('page-container').scrollIntoView();
      }
      const response = await this.getAllQuestions({
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        ...(this.ordering && { ordering: this.ordering }),
        ...(this.searchTerm && { search: this.searchTerm }),
        topic: this.filters.topic,
        ...(this.filters.program && { program: this.filters.program }),
        ...(this.filters.tag && { tag: this.filters.tag }),
        ...((this.getLoggedInUserDashboard === DASHBOARD_TYPES.ORGANIZATION ||
          get(this.getLoggedInUser, 'role_type') === USER_ROLE_TYPES.ORGANIZATION) &&
          get(this.getLoggedInUser, 'linked_entity.id') && { organization: this.getLoggedInUser.linked_entity.id }),
        ...params,
      });

      this.questions = response.data.results;
      this.currentPage = pageNum;
      this.totalQuestions = response.data.count;
      this.pageFromCount = (this.currentPage - 1) * this.perPage + 1;
      this.pageToCount = this.pageFromCount + get(response.data, 'results.length', 0) - 1;
      this.isLoading = false;
    },

    onPageChange(pageNum) {
      this.fetchQuestions(pageNum);
    },

    onSortChange(context) {
      this.ordering = context.sortDesc ? '-' + context.sortBy : context.sortBy;
      this.fetchQuestions();
    },

    onSearch() {
      this.debouncedSearchQuestions(this);
    },

    debouncedSearchQuestions: debounce(vm => {
      vm.fetchQuestions();
    }, 500),

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },

  async mounted() {
    window.addEventListener('resize', this.handleResize);
    if ([this.USER_ROLES.SCHOOL_OWNER, this.USER_ROLES.SCHOOL_ADMIN].includes(get(this.getLoggedInUser, 'role'))) {
      await this.fetchPrograms();
    }
    this.fetchQuestions();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
.ques-description-preview {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
  word-break: break-word;
}
.ques-description-preview >>> img,
.ques-description-preview >>> table,
.ques-description-preview >>> iframe {
  max-width: 100%;
}
.ques-description-preview >>> p:last-child {
  margin-bottom: 0;
}
</style>
